import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLocation } from "react-router-dom";
const LINKS = [
    { to: "/orders", label: "Orders", key: "orders" },
    { to: "/onboarding", label: "Connect Store", key: "onboarding" },
    { to: "/auto-cancel", label: "Auto-Cancel", key: "autocancel" },
    { to: "/cost-report", label: "Cost Report", key: "costreport" },
    { to: "/billing", label: "Billing", key: "billing" },
];
export default function Nav({ active }) {
    const location = useLocation();
    return (_jsxs("nav", { className: "topnav", role: "navigation", "aria-label": "Main navigation", children: [_jsxs(Link, { to: "/orders", className: "topnav-brand", "aria-label": "COD Verifier home", children: [_jsx("div", { className: "topnav-logo", "aria-hidden": "true", children: "C" }), _jsx("span", { className: "topnav-name", children: "COD Verifier" })] }), _jsx("ul", { className: "topnav-links", style: { listStyle: "none" }, children: LINKS.map((link) => {
                    const isActive = active === link.key ||
                        (!active && location.pathname === link.to);
                    return (_jsx("li", { children: _jsx(Link, { to: link.to, className: `topnav-link${isActive ? " active" : ""}`, "aria-current": isActive ? "page" : undefined, children: link.label }) }, link.key));
                }) })] }));
}
